module.exports = __webpack_public_path__ + "assets/img/cloud4.f7b341b2.webp";